import { PRIVATEPATHS } from '@core/enums/paths.enum';
import { SideBarItem } from '@core/models/generic.model';
import {
    ArrowLeftRight,
    CircleDollarSign,
    FlagIcon,
    Flower,
    Megaphone,
    MonitorDot,
    Settings,
    SquareUser,
    Store,
    UserRound,
    HandCoins,
    Cuboid,
    ShoppingCart,
    Handshake,
    Box,
    Pill,
    Trophy,
    Building2,
    Building,
    Factory,
    PlusCircle,
    FolderTree,
    Subtitles,
    Package,
    LifeBuoy,
    History,
    FileText,
    Package2,
    HistoryIcon,
    PackageCheck,
    ShoppingBag,
    MessageSquare,
    PackageX,
    Bell,
    Map,
    RefreshCcw,
    Truck,
    Mail,
    Printer,
} from 'lucide-react';

const menuData: Array<SideBarItem> = [
    {
        id: `dashboard`,
        label: `Dashboard`,
        link: PRIVATEPATHS.Dashboard,
        icon: <MonitorDot />,
    },
    {
        id: `Map`,
        label: `Map`,
        link: PRIVATEPATHS.Map,
        icon: <Map />,
    },
    {
        id: `Users-list`,
        label: `Users list`,
        icon: <UserRound />,
        link: PRIVATEPATHS.UserListing,
    },
    {
        id: `Products`,
        label: `Products`,
        icon: <ShoppingCart />,
        link: PRIVATEPATHS.Products,
    },
    {
        id: `Offers`,
        label: `Offers`,
        icon: <Megaphone />,
        link: PRIVATEPATHS.Offers,
    },
    {
        id: `Orders`,
        label: `Orders`,
        icon: <ShoppingBag />,
        link: PRIVATEPATHS.Orders,
    },
    {
        id: `PosSettings`,
        label: `POS / Receipt`,
        icon: <Printer />,
        link: PRIVATEPATHS.PosSettings,
    },
    {
        id: `Backorders`,
        label: `Backorders`,
        icon: <PackageCheck />,
        link: PRIVATEPATHS.Backorders,
    },
    {
        id: `Dosage`,
        label: `Dosage`,
        icon: <Pill />,
        link: PRIVATEPATHS.Dosage,
    },
    {
        id: `Tier`,
        label: `Tier`,
        icon: <Trophy />,
        link: PRIVATEPATHS.Tier,
    },
    {
        id: `Warehouse`,
        label: `Warehouse`,
        icon: <Building />,
        link: PRIVATEPATHS.Warehouse,
    },
    {
        id: `Manufacturer`,
        label: `Manufacturer`,
        icon: <Factory />,
        link: PRIVATEPATHS.Manufacturer,
    },
    {
        id: `Supplier`,
        label: `Supplier`,
        icon: <PlusCircle />,
        link: PRIVATEPATHS.Supplier,
    },
    {
        id: `ProductCategory`,
        label: `Product Category`,
        icon: <FolderTree />,
        link: PRIVATEPATHS.ProductCategory,
    },
    {
        id: `ProductSubCategory`,
        label: `Product Sub Category`,
        icon: <Subtitles />,
        link: PRIVATEPATHS.ProductSubCategory,
    },
    {
        id: `Batch`,
        label: `Batch`,
        icon: <Box />,
        link: PRIVATEPATHS.Batch,
    },
    {
        id: `InventoryManagement`,
        label: `Inventory Management`,
        icon: <Package2 />,
        link: PRIVATEPATHS.InventoryManagement,
    },
    {
        id: `ProductLifeCycle`,
        label: `Product Life Cycle`,
        icon: <LifeBuoy />,
        link: PRIVATEPATHS.ProductLifeCycle,
    },
    {
        id: `Traceability`,
        label: `Traceability`,
        icon: <History />,
        link: PRIVATEPATHS.Traceability,
    },
    {
        id: `TransactionStatements`,
        label: `Transaction Statements`,
        icon: <FileText />,
        link: PRIVATEPATHS.TransactionStatements,
    },
    {
        id: `Audit`,
        label: `Audit`,
        icon: <HistoryIcon />,
        link: PRIVATEPATHS.Audit,
    },
    {
        id: `Epcis`,
        label: `EPCIS`,
        icon: <Package2 />,
        link: PRIVATEPATHS.Epcis,
    },
    {
        id: `SftpIntegrations`,
        label: `SFTP Integrations`,
        icon: <Package2 />,
        link: PRIVATEPATHS.SftpIntegrations,
    },
    {
        id: `As2`,
        label: `AS2`,
        icon: <Package2 />,
        subItems: [
            {
                id: `As2Messages`,
                label: `Messages`,
                link: PRIVATEPATHS.As2Messages,
            },
            {
                id: `As2Partners`,
                label: `Partners`,
                link: PRIVATEPATHS.As2Partners,
            },
            {
                id: `Integrations`,
                label: `Setup & health`,
                link: PRIVATEPATHS.Integrations,
            },
        ],
    },
    {
        id: `Bullk`,
        label: `Bullk`,
        icon: <PackageCheck />,
        link: PRIVATEPATHS.Bullk,
    },
    {
        id: `Comments`,
        label: `Comments`,
        icon: <MessageSquare />,
        link: PRIVATEPATHS.Comments,
    },
    {
        id: `Alert`,
        label: `Alert`,
        icon: <Bell />,
        link: PRIVATEPATHS.Alert,
    },
    {
        id: `Returns`,
        label: `Returns`,
        icon: <RefreshCcw/>,
        link: PRIVATEPATHS.Returns,
    },
    {
        id: `Shipments`,
        label: `Shipments`,
        icon: <Truck />,
        link: PRIVATEPATHS.Shipments,
    },
    {
        id: `ContactSubmissions`,
        label: `Contact Submissions`,
        icon: <Mail />,
        link: PRIVATEPATHS.ContactSubmissions,
    },
];

export { menuData };
